//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    thumbStyle: {
      type: Object,
      default: undefined,
    },
  },
}
